export default {
  no_documents:
    'Sie haben derzeit keine Dokumente. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support für Unterstützung.',
}
